import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';

const Title = styled.div`
  font-size: 13px;
  font-size: medium;
  line-height: 17px;
  margin-bottom: 5px;
`;

const CoachType = ({ children }) => <Title>{children}</Title>;

CoachType.propTypes = {
  children: PropTypes.arrayOf(PropTypes.string)
};

CoachType.defaultProps = {
  children: null
};

export default CoachType;



// WEBPACK FOOTER //
// ./src/components/CoachInfos/CoachType.jsx